export const QuestionRemove = "QuestionRemove";
export const UpdateDataSuccessfully = "UpdateDataSuccessfully";
export const DefaultErrorMessage = "DefaultErrorMessage";
export const TheFieldIsRequired = "TheFieldIsRequired";
export const TheFieldIsExisted = "TheFieldIsExisted";
export const TheFieldIsNotFound = "TheFieldIsNotFound";
export const SelectTheField = "SelectTheField";
export const SearchByTheField = "SearchByTheField";
export const PleaseDeleteBlogInCategory = "PleaseDeleteBlogInCategory";
export const DeleteNumber = "DeleteNumber";
export const Name = "Name";
export const Title = "Title";
export const Slug = "Slug";
export const Category = "Category";
export const UpdateTheField = "UpdateTheField";
export const AddTheField = "AddTheField";
export const Successfully = "Successfully";
export const NotificationText = "NotificationText";
export const Save = "Save";
export const Cancel = "Cancel";
export const Delete = "Delete";
export const Add = "Add";
export const Update = "Update";
export const Back = "Back";
export const ImageText = "ImageText";
export const Description = "Description";
export const MetaTitle = "MetaTitle";
export const MetaDescription = "MetaDescription";
export const MetaKeyword = "MetaKeyword";
export const Theme = "Theme";
export const Blog = "Blog";
export const MainCategory = "MainCategory";
export const Information = "Information";
export const ContentText = "ContentText";
export const RelatedCategory = "RelatedCategory";
export const CreationTime = "CreationTime";
export const LastModificationTime = "LastModificationTime";
export const Page = "Page";
export const MenuText = "MenuText";
export const StaticPage = "StaticPage";
export const StaticPageCustom = "StaticPageCustom";
export const Keyword = "Keyword";
export const OkText = "OkText";
export const Avatar = "Avatar";
export const Sort = "Sort";
export const Classify = "Classify";
export const ElementText = "ElementText";
export const ListText = "ListText";
export const ThemeManagerText = "ThemeManagerText";
export const ThemeListText = "ThemeListText";
export const NameField = "NameField";
export const GroupText = "GroupText";
export const TextStyle = "TextStyle";
export const Email = "Email";
export const Phone = "Phone";
export const Birthday = "Birthday";
export const GoogleMap = "GoogleMap";
export const Street = "Street";
export const City = "City";
export const State = "State";
export const ZipCode = "ZipCode";
export const Facebook = "Facebook";
export const Instagram = "Instagram";
export const Youtube = "Youtube";
export const MapText = "MapText";
export const Address = "Address";
export const Attribute = "Attribute";
export const GroupFieldText = "GroupFieldText";
export const AttributeValue = "AttributeValue";
export const CommentsReviews = "CommentsReviews";
export const ContactText = "ContactText";
export const CouponText = "CouponText";
export const CustomerText = "CustomerText";
export const CustomizeCss = "CustomizeCss";
export const CustomizeJs = "CustomizeJs";
export const DateFormat = "DateFormat";
export const DateTimeFormat = "DateTimeFormat";
export const ManagerText = "ManagerText";
export const OrderText = "OrderText";
export const Permission = "Permission";
export const PriceRangeText = "PriceRangeText";
export const ProductLabel = "ProductLabel";
export const ProductText = "ProductText";
export const ShippingFee = "ShippingFee";
export const StaffText = "StaffText";
export const StaffField = "StaffField";
export const Url = "Url";
export const WebsiteConfigText = "WebsiteConfigText";
export const WebsiteInfoText = "WebsiteInfoText";
export const NotificationEmailList = "NotificationEmailList";
export const TimeZone = "TimeZone";
export const IsActive = "IsActive";
export const GPosSetting = "GPosSetting";
export const MxMerchantSetting = "MxMerchantSetting";
export const DefaultPrinterIp = "DefaultPrinterIp";
export const UserPosPrinter = "UserPosPrinter";
export const ShopCode = "ShopCode";
export const DeviceCode = "DeviceCode";
export const MerchantId = "MerchantId";
export const UserName = "UserName";
export const Password = "Password";
export const IsSandbox = "IsSandbox";
export const BranchText = "BranchText";
export const SalonServiceCategoryText = "SalonServiceCategoryText";
export const GalleryText = "GalleryText";
export const StatusText = "StatusText";
export const ConfirmText = "ConfirmText";
export const QuestionUpdate = "QuestionUpdate";
export const NeverSeenText = "NeverSeenText";
export const SeenText = "SeenText";
export const CompleteText = "CompleteText";
export const SalonService = "SalonService";
export const Price = "Price";
export const Duration = "Duration";
export const ShowPlusAfterPrice = "ShowPlusAfterPrice";
export const DefaultText = "DefaultText";
export const SalonStaff = "SalonStaff";
export const AppointmentSettingText = "AppointmentSettingText";
export const SessionLength = "SessionLength";
export const TimeTable = "TimeTable";
export const PleaseSelectTheField = "PleaseSelectTheField";
export const AppointmentHistoryText = "AppointmentHistoryText";
export const AppointmentText = "AppointmentText";
export const Major = "Major";
export const BranchInfoText = "BranchInfoText";
export const CategoryGposText = "CategoryGposText";
export const ProductGposText = "ProductGposText";
export const ModifierGposText = "ModifierGposText";
export const OrderPickupSettingText = "OrderPickupSettingText";
export const OrderPickupHistoryText = "OrderPickupHistoryText";
export const SyncGposText = "SyncGposText";
export const CustomNameText = "CustomNameText";
export const UpdateSkuText = "UpdateSkuText";
export const IsShowAllSku = "IsShowAllSku";
export const IsSoldOut = "IsSoldOut";
export const UpdateMoreInfoText = "UpdateMoreInfoText";
export const MaxOrdersPerSessionText = "MaxOrdersPerSessionText";
export const OffDateText = "OffDateText";
export const SelectOffDateText = "SelectOffDateText";
export const SpecialDateText = "SpecialDateText";
export const SelectSpecialDateText = "SelectSpecialDateText";
export const OpenTimeText = "OpenTimeText";
export const CloseTimeText = "CloseTimeText";
export const SelectAnotherDateText = "SelectAnotherDateText";
export const OrderNumberText = "OrderNumberText";
export const DateFromText = "DateFromText";
export const DateToText = "DateToText";
export const PaymentStatusText = "PaymentStatusText";
export const SpendingText = "SpendingText";
export const PaidText = "PaidText";
export const TimeBeforeAppointment = "TimeBeforeAppointment";
export const OrderDateTime = "OrderDateTime";
export const SubtotalAmountText = "SubtotalAmountText";
export const TotalAmountText = "TotalAmountText";
export const TipAmountText = "TipAmountText";
export const TaxAmountText = "TaxAmountText";
export const DiscountAmountText = "DiscountAmountText";
export const ExportExcelText = "ExportExcelText";
export const PleaseWaitUpdateText = "PleaseWaitUpdateText";
export const StatisticalText = "StatisticalText";
export const GiftCardCouponText = "GiftCardCouponText";
export const CouponTypeText = "CouponTypeText";
export const StartDateText = "StartDateText";
export const EndDateText = "EndDateText";
export const IsOneTimeUsed = "IsOneTimeUsed";
export const AmountMin = "AmountMin";
export const AmountMax = "AmountMax";
export const LessMoreType = "LessMoreType";
export const InActive = "InActive";
export const ValueText = "ValueText";
export const AmountLess = "AmountLess";
export const AmountMore = "AmountMore";
export const AmountText = "AmountText";
export const PercentText = "PercentText";
export const MinimumAmount = "MinimumAmount";
export const GiftCardSettingText = "GiftCardSettingText";
export const GiftCardText = "GiftCardText";
export const GiftCardCodeText = "GiftCardCodeText";
export const RecipientText = "RecipientText";
export const EmailField = "EmailField";
export const PhoneField = "PhoneField";
export const GiftCardHistoryText = "GiftCardHistoryText";
export const TheFieldInformation = "TheFieldInformation";
export const GiftCardWeb = "GiftCardWeb";
export const UseService = "UseService";
export const FirstName = "FirstName";
export const LastName = "LastName";
export const GiftCardTemplateText = "GiftCardTemplateText";
export const RequestDateTime ="RequestDateTime";
export const BookingType = "BookingType";
export const NumberOfPeople = "NumberOfPeople";
export const TotalText = "TotalText";
export const GiftCardHistoryWebText = "GiftCardHistoryWebText";
export const BlockTimeWithOneLineAppointment ="BlockTimeWithOneLineAppointment";
export const ExtensionField  = "ExtensionField";